// src/components/tasks/ui/TaskChatUI.tsx
import { cn } from "@/lib/utils"
import type { ReactNode, HTMLAttributes } from "react"

export const taskChatTheme = {
  // Основной контейнер чата — стекло
  mainContainer: "flex flex-col h-full bg-purple-950/80 backdrop-blur-2xl border border-purple-300/40 rounded-3xl overflow-hidden shadow-2xl shadow-purple-500/20",

  // Шапка
  header: "px-6 py-4 bg-purple-950/70 backdrop-blur-2xl border-b border-purple-300/40 text-white",

  // Левая боковая панель
  sidebar: "w-[40%] border-r border-purple-300/30 bg-purple-950/60 backdrop-blur-xl p-5 overflow-y-auto no-scrollbar",

  // Область чата
  chatArea: "flex-1 flex flex-col min-h-0 bg-purple-950/40 relative",

  // Поисковая строка — glass
  searchBar: "pl-12 bg-purple-950/70 border border-purple-300/40 text-white placeholder:text-purple-400/70 rounded-3xl text-base h-11 focus:border-purple-400",

  // Блоки в сайдбаре
  sidebarSection: "bg-purple-950/70 border border-purple-300/40 rounded-3xl p-4",
  sidebarObserverSection: "bg-purple-950/70 border border-amber-300/40 rounded-3xl p-4",

  // Блок документов
  documentsBlock: "bg-gradient-to-br from-purple-900/80 to-fuchsia-950/70 border border-purple-300/40 rounded-3xl p-5 shadow-xl",

  // Пустое состояние
  emptyState: "flex flex-col items-center justify-center h-full text-purple-400 gap-6 py-12",

  // Облачко сообщения
  messageBubble: (isOwn: boolean, isFirstInGroup: boolean) => cn(
    "group relative max-w-[72%] px-5 py-3 rounded-3xl text-base leading-relaxed shadow-xl transition-all duration-200 hover:shadow-2xl cursor-pointer",
    isOwn
      ? "bg-gradient-to-br from-purple-600/95 to-pink-600/92 text-white rounded-br-none ml-auto"
      : "bg-purple-950/70 backdrop-blur-xl border border-purple-300/40 text-purple-100 rounded-bl-none",
    isFirstInGroup
      ? isOwn ? "rounded-tr-3xl" : "rounded-tl-3xl"
      : isOwn ? "rounded-tr-2xl rounded-br-2xl" : "rounded-tl-2xl rounded-bl-2xl"
  ),

  // Прикреплённый файл (исправлено выравнивание кнопки)
  fileAttachment: "mt-3 bg-purple-950/60 backdrop-blur-xl border border-purple-300/30 rounded-3xl p-4 flex items-center justify-between gap-4",

  // Панель ввода — glass
  inputBar: "p-5 border-t border-purple-300/30 bg-purple-950/70 backdrop-blur-2xl",

  // Аватары
  avatarOwn: "bg-gradient-to-br from-purple-600 to-pink-600 text-white text-xs font-bold",
  avatarOther: "bg-gradient-to-br from-blue-600 to-cyan-600 text-white text-xs font-bold",

  // Дополнительные стили
  emojiPopoverContent: "w-80 p-5 bg-purple-950/90 backdrop-blur-2xl border border-purple-300/40 rounded-3xl shadow-2xl",
  emojiButton: "!h-14 !w-14 p-0 rounded-full hover:bg-purple-900/40",
  emojiItem: "text-4xl hover:scale-125 active:scale-95 transition-all duration-200 p-3 rounded-2xl hover:bg-white/10 flex items-center justify-center aspect-square",
  replyBanner: "bg-purple-900/40 border-t border-purple-300/40 px-5 py-2.5 flex items-center gap-3",
  editingTextarea: "w-full bg-purple-950/60 border border-purple-300/40 rounded-2xl px-4 py-3 text-base text-white resize-none focus:outline-none focus:border-purple-400 font-normal",
  dateSeparator: "bg-purple-950/80 px-5 py-2 rounded-full text-sm text-purple-300 border border-purple-300/40 shadow-md",
  typingIndicator: "text-purple-400/70 italic text-base mt-6 text-center animate-pulse",
} as const

export function MessageBubble({
  isOwn,
  isFirstInGroup,
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & { isOwn: boolean; isFirstInGroup: boolean }) {
  return (
    <div
      className={cn(taskChatTheme.messageBubble(isOwn, isFirstInGroup), className)}
      {...props}
    >
      {children}
    </div>
  )
}